import { render, staticRenderFns } from "./SearchBarPosts.vue?vue&type=template&id=8beb5762&scoped=true"
import script from "./SearchBarPosts.vue?vue&type=script&lang=js"
export * from "./SearchBarPosts.vue?vue&type=script&lang=js"
import style0 from "./SearchBarPosts.vue?vue&type=style&index=0&id=8beb5762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8beb5762",
  null
  
)

export default component.exports